"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _react = _interopRequireDefault(require("react"));

var _reactAutobind = _interopRequireDefault(require("react-autobind"));

var _reactIntl = require("react-intl");

var _reactComponents = require("@cimpress/react-components");

var _ListPriceInitiatorWizardModal = _interopRequireDefault(require("./ListPriceInitiatorWizardModal"));

var _constants = require("./constants");

var _logger = require("../logger");

var _withI18n = _interopRequireDefault(require("../i18n/withI18n"));

var _listPriceInitiatorMessages = require("./listPriceInitiatorMessages");

var ListPriceInitiatorButton =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ListPriceInitiatorButton, _React$PureComponent);

  function ListPriceInitiatorButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ListPriceInitiatorButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ListPriceInitiatorButton).call(this, props));
    (0, _reactAutobind.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
    _this.state = {
      showModal: false
    };
    _this.componentName = 'ListPriceInitiatorButton';
    _this.logger = (0, _logger.getLoggerForToken)(props.onGetAccessToken);

    _this.logger.info('ListPriceInitiatorButton in use', _this.componentName);

    return _this;
  }

  (0, _createClass2.default)(ListPriceInitiatorButton, [{
    key: "onCloseModal",
    value: function onCloseModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "onOpenModal",
    value: function onOpenModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          productFulfiller = _this$props.productFulfiller,
          allowedMerchants = _this$props.allowedMerchants,
          skus = _this$props.skus,
          skuFamily = _this$props.skuFamily,
          disabled = _this$props.disabled,
          onGetAccessToken = _this$props.onGetAccessToken,
          isProduction = _this$props.isProduction,
          contractCreationCallback = _this$props.contractCreationCallback,
          _this$props$intl = _this$props.intl;
      _this$props$intl = _this$props$intl === void 0 ? this.props : _this$props$intl;
      var formatMessage = _this$props$intl.formatMessage,
          locale = _this$props$intl.locale; // make sure that there are no duplicate skus by turning the sku list into a set

      var skuSet = new Set(skus);
      var filteredSkus = (0, _toConsumableArray2.default)(skuSet);
      var savedMerchantId = this.state.savedMerchantId;
      var invalidAllowedMerchants = !allowedMerchants || allowedMerchants.length === 0;
      var noMerchantIdentity = disabled || invalidAllowedMerchants || this.state.showModal;
      var noMarketableSkus = filteredSkus.length === 0;
      var shouldDisable = noMerchantIdentity || noMarketableSkus;

      var btn = _react.default.createElement("button", {
        className: "btn btn-primary ".concat(shouldDisable ? 'btn-disabled' : ''),
        onClick: shouldDisable ? null : this.onOpenModal
      }, formatMessage(_listPriceInitiatorMessages.listPriceInitiatorButtonMessages.listPriceInitiatorButtonText));

      var disableMsg = noMerchantIdentity ? formatMessage(_listPriceInitiatorMessages.listPriceInitiatorButtonMessages.noIdentityMessage) : formatMessage(_listPriceInitiatorMessages.listPriceInitiatorButtonMessages.noSkusSelectedMessage);
      var innerRender = shouldDisable ? _react.default.createElement(_reactComponents.Tooltip, {
        direction: "top",
        contents: formatMessage(_listPriceInitiatorMessages.listPriceInitiatorButtonMessages.tooltipMessage, {
          message: disableMsg,
          email: _constants.FFS_EMAIL_ADDRESS
        })
      }, btn) : btn;
      return _react.default.createElement("div", {
        className: "list-price-contract-term-button"
      }, _react.default.createElement(_ListPriceInitiatorWizardModal.default, {
        productFulfiller: productFulfiller,
        allowedMerchants: savedMerchantId ? [savedMerchantId] : allowedMerchants,
        skus: filteredSkus,
        skuFamily: skuFamily,
        show: this.state.showModal,
        onClose: this.onCloseModal,
        onGetAccessToken: onGetAccessToken,
        isProduction: isProduction,
        locale: locale,
        contractCreationCallback: contractCreationCallback
      }), innerRender);
    }
  }]);
  return ListPriceInitiatorButton;
}(_react.default.PureComponent);

ListPriceInitiatorButton.defaultProps = {
  disabled: true
};

var _default = (0, _withI18n.default)((0, _reactIntl.injectIntl)(ListPriceInitiatorButton));

exports.default = _default;